<template>
  <div class="backend-article-page">
    <van-nav-bar
      :title="article.title || fallbackTitle"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="goBack"
    />
    <main v-if="article.id" class="backend-article-body">
      <h1>{{ article.title }}</h1>
      <img
        v-if="article.image && !imageFailed"
        :key="articleImage"
        class="backend-cover"
        :src="articleImage"
        :alt="article.title"
        @load="imageFailed = false"
        @error="hideBrokenImage"
      />
      <div class="backend-rich-content" v-html="article.content"></div>
    </main>
    <div v-else-if="loading" class="backend-article-state">正在加载后台内容…</div>
    <div v-else class="backend-article-state">{{ errorMessage || "后台尚未发布内容" }}</div>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "BackendArticlePage",
  props: {
    pageCode: { type: String, required: true },
    fallbackTitle: { type: String, default: "说明文件" }
  },
  data() {
    return {
      article: {},
      loading: true,
      errorMessage: "",
      imageFailed: false,
      imageVersion: 0
    };
  },
  computed: {
    articleImage() {
      if (!this.article.image) return "";
      const separator = this.article.image.indexOf("?") === -1 ? "?" : "&";
      return `${this.article.image}${separator}v=${this.imageVersion}`;
    }
  },
  watch: {
    pageCode: {
      immediate: true,
      handler() {
        this.loadArticle();
      }
    }
  },
  activated() {
    if (this.article.id) this.loadArticle();
  },
  methods: {
    loadArticle() {
      this.loading = true;
      this.errorMessage = "";
      request
        .get(
          "/api/v1/article/page",
          { code: this.pageCode, _t: Date.now() },
          { login: false }
        )
        .then(res => {
          this.imageFailed = false;
          this.imageVersion = Date.now();
          this.article = (res && res.data && res.data.data) || {};
        })
        .catch(err => {
          this.article = {};
          this.imageFailed = false;
          this.errorMessage =
            err && err.response && err.response.data && err.response.data.msg
              ? err.response.data.msg
              : "内容加载失败，请稍后重试";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push("/");
    },
    hideBrokenImage() {
      this.imageFailed = true;
    }
  }
};
</script>

<style scoped>
.backend-article-page {
  min-height: 100vh;
  background: #fff;
}
.backend-article-page /deep/ .van-nav-bar__title {
  max-width: 72%;
}
.backend-article-body {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 20px 16px calc(112px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
.backend-article-body > h1 {
  margin: 0 0 18px;
  font-size: 22px;
  line-height: 1.45;
  text-align: center;
}
.backend-cover {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 18px;
}
.backend-rich-content {
  min-width: 0;
  padding-bottom: 8px;
  font-size: 16px;
  line-height: 1.75;
  overflow-wrap: anywhere;
}
.backend-rich-content /deep/ p {
  margin: 0 0 12px;
}
.backend-rich-content /deep/ img {
  max-width: 100% !important;
  height: auto !important;
}
.backend-rich-content /deep/ video,
.backend-rich-content /deep/ iframe {
  display: block;
  max-width: 100% !important;
}
.backend-rich-content /deep/ table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}
.backend-article-state {
  padding: 80px 18px;
  color: #8590a0;
  text-align: center;
}
</style>
